import { Type } from 'class-transformer'
import { EnumEntity } from '..'

import { Person } from '.'

export class Gender extends EnumEntity {
  @Type(() => Person)
  people: Person[];
}
